import React from 'react';

import { useRecoilQuery } from '../../../../../../../../hooks/useRecoilQuery';
import { coesMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const CoesButton: React.FC<ProductButtonProps<'coes'>> = (props) => {
  const { data } = useRecoilQuery(coesMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen;

  return (
    <ApplicationButton
      {...props}
      isDisabled={props.isDisabled || forceButtonDisable}
      idSelector="productIdNormalized"
    />
  );
};
